import { isFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18605
// Запуск восстановления файлов оверквотеров по deeplink
export const overquotaRestoreLink: boolean = isFeature('overquota-restore-link') || false;
